export enum Theme {
    NEUTRAL = 'neutral',
    ACCENT = 'accent'
}



// WEBPACK FOOTER //
// ./src/enums/Theme.ts